import { AttrOptStrIds, AttributeConfigId, AttributeOptionId, FeatureStringIdEnum } from './../types/project-config';
export type ObjID = number | AttributeConfigId | AttributeOptionId;
export enum IDKeyTypes {
  Invalid = -1,
  Points = 1, Segments, Supplemental,
  AttributeOption,
  PointAttributes, SegmentAttributes, SupplementalAttributes,
  PointAttributeCondition, SegmentAttributeCondition,
  PointPreset, SegmentPreset,
  Route, PointFeature, LineFeature, SegmentFeature, PolyFeature,
  RoutePart,
  Annotation
}
export type IDManagerKeySet = {
  [key: number]: number;
}
export class IDManager {
  private keys: IDManagerKeySet;
  private maxDigits = 2;
  constructor() {
    this.keys = [];
    this.Reset();
    this.ID(IDKeyTypes.PointAttributes, AttrOptStrIds['control-point']);
    this.ID(IDKeyTypes.PointAttributes, AttrOptStrIds['transition-point']);
  }
  ResetConfigIds() {
    for (const keyIndex in this.keys) {
      if (this.keys.hasOwnProperty(keyIndex)) {
        this.keys[keyIndex] = -1;
      }
    }
  }
  ID(type: IDKeyTypes, value?: number): ObjID {
    if (type < 0) return -1;
    if (('' + value).length < this.maxDigits) {
      value = 0;
    }
    if (value !== undefined) {
      this.keys[type] = Math.max(this.keys[type], this.TrimType(value) as number);
      return value;
    } else {
      if (this.keys[type] === undefined) this.keys[type] = -1;
      this.keys[type] += 1;
    }

    const suffix = this.MakeIDSuffix(type);
    return Number(`${this.keys[type]}${suffix}`);
  }
  TrimType(id: ObjID): ObjID {
    if (typeof id !== 'number') return id;
    const idString = '' + id;
    return Number(idString.substring(0, idString.length - 2)) as ObjID;
  }
  IDType(id: ObjID): IDKeyTypes {
    if (typeof id === 'string') {
      id = this.FromStringID(id);
      if (id < 0) return IDKeyTypes.Invalid;
    }
    const idString: string = '' + id;
    return Number(idString.substring(idString.length - this.maxDigits));
  }
  private MakeIDSuffix(type: IDKeyTypes): string {
    return ('' + type).padStart(this.maxDigits, '0');
  }
  FromID(id: ObjID): number {
    if (typeof id === 'string') {
      return this.FromStringID(id);
    }
    return id;
  }

  FromStringID(id: string): number {
    const suffix = this.MakeIDSuffix(IDKeyTypes.PointAttributes);
    switch (id) {
      case 'control-point':
        return Number(AttrOptStrIds['control-point'] + suffix);
        break;
      case 'transition-point':
        return Number(AttrOptStrIds['transition-point'] + suffix);
        break;
      case 'pointName':
        return Number(FeatureStringIdEnum['pointName'] + suffix);
      case 'segmentName':
        return Number(FeatureStringIdEnum['segmentName'] + this.MakeIDSuffix(IDKeyTypes.SegmentAttributes));

      case 'pointType':
        return Number(FeatureStringIdEnum['pointType'] + suffix);
      case 'segmentType':
        return Number(FeatureStringIdEnum['segmentType'] + this.MakeIDSuffix(IDKeyTypes.SegmentAttributes));

    }
    const numericId = Number(id);
    if (isNaN(numericId)) return -1;
    return this.FromID(numericId);
  }
  Reset() {
    this.keys[IDKeyTypes.Points] = -1;
    this.keys[IDKeyTypes.Segments] = -1;
    this.keys[IDKeyTypes.Supplemental] = -1;
    this.keys[IDKeyTypes.PointAttributes] = -1;
    this.keys[IDKeyTypes.SegmentAttributes] = -1;
    this.keys[IDKeyTypes.SupplementalAttributes] = -1;
    this.keys[IDKeyTypes.AttributeOption] = -1;
    this.keys[IDKeyTypes.PointAttributeCondition] = -1;
    this.keys[IDKeyTypes.SegmentAttributeCondition] = -1;

  }
  ToJSON(asString = false): string | IDManagerKeySet {
    const jsonString = JSON.stringify(this.keys);
    if (asString) return jsonString;
    return JSON.parse(jsonString) as IDManagerKeySet;
  }
  SetKeySet(keys: IDManagerKeySet) {
    this.keys = keys;
  }
}
